// --- Core ---
import {useMemo} from "react";
import {FormattedMessage} from "react-intl";
import {findWhere, map} from "underscore";
// --- Material UI ---
import {MenuItem} from "@mui/material";
// --- SaniQ ---
import {SelectField} from "helpers/Forms";
import {LocaleItemContent, LocaleItemContentProps} from "shared/Locale";
import {Locale, localeDefinitions} from "src/config/i18n";

interface LocaleFieldProps {
  // The list of locales to display as options
  locales: Locale[];
  contentProps: LocaleItemContentProps;
}

/**
 * A field component for selecting a locale.
 */
export const LocaleField = ({contentProps, locales = Object.values(Locale), ...rest}: LocaleFieldProps) => {
  const definitions = useMemo(() => map(locales, locale => findWhere(localeDefinitions, {key: locale})), [locales]);

  return (
    // @ts-expect-error SelectField typing is not done yet
    <SelectField
      label={<FormattedMessage id="system.locales.label" defaultMessage="Locale"/>}
      SelectDisplayProps={{style: {display: 'flex', alignItems: "center"}}}
      {...rest}
    >
      {
        map(definitions, (definition) => (
          <MenuItem value={definition.key} key={definition.key} dense>
            <LocaleItemContent definition={definition} showSecondary {...contentProps}/>
          </MenuItem>
        ))
      }
    </SelectField>
  );
};
